/* eslint-disable @typescript-eslint/naming-convention */
export interface ISetPinnedRequestRaw {
  is_pinned: boolean;
}

export const toSetPinnedRequest = (pinned: boolean): ISetPinnedRequestRaw => ({ is_pinned: pinned });
/* eslint-enable @typescript-eslint/naming-convention */
